import { gql } from '@apollo/client';
import { CustomerTaxExemptionInfo } from '../fragments';

export default gql`
  query CustomerTaxExemptions($accountId: ID, $state: String) {
    customerTaxExemptions(accountId: $accountId, state: $state) {
      ...CustomerTaxExemptionInfo
    }
  }
  ${CustomerTaxExemptionInfo}
`;
